import * as React from 'react';
import { Dialog } from 'components/dialog';
import { CheckBox } from 'components/input/CheckBox';
import { Button } from '@material-ui/core';
import { GeneralSettingsController } from './controller/GeneralSettingsController';

export class EditWorkdaysDialog extends React.Component<Props, State> {

    private static readonly days: string[] = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    public constructor(props: Props) {
        super(props);

        var wd: boolean[] = [];
        for (var w of props.workdays) {
            wd.push(w);
        }

        this.state = { workdays: wd };

        this.handleSaveClicked = this.handleSaveClicked.bind(this);
        this.handleCancelClicked = this.handleCancelClicked.bind(this);
        this.handleItemChange = this.handleItemChange.bind(this);
    }

    private handleSaveClicked() {
        this.props.controller.onSaveWorkdaysClicked(this.state.workdays);
    }

    private handleCancelClicked() {
        this.props.controller.onCancelEditWorkdaysClicked();
    }

    private handleItemChange(index: number, newValue: boolean) {
        var s = this.state;
        s.workdays[index] = newValue;
        this.setState(s);
    }

    public render() {
        return (
            <Dialog title="Edit workdays">
                {this.state.workdays.map((item, index) => {
                    return (
                        <div key={"cbwd-" + index}>
                            <CheckBox label={EditWorkdaysDialog.days[index]} checked={item} onChange={(newValue) => {
                                this.handleItemChange(index, newValue);
                            }} />
                        </div>
                    )
                })}

                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <Button color="secondary" onClick={this.handleCancelClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleSaveClicked}>Save</Button>
                </div>
            </Dialog>
        );
    }

}

export interface Props {

    workdays: boolean[];
    controller: GeneralSettingsController;

}

interface State {
    workdays: boolean[];
}